import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Function to check if the token is about to expire (with a 30-second buffer)
const isTokenExpired = () => {
  const expiryTime = localStorage.getItem("expires");
  const bufferTime = 30 * 1000; // 30 seconds in milliseconds
  return expiryTime ? Date.now() > parseInt(expiryTime) - bufferTime : true;
};

// Request interceptor to add Authorization token
axiosInstance.interceptors.request.use(
  async (request) => {
    let token = localStorage.getItem("token");

    // Check if the token is about to expire before making the request
    if (isTokenExpired()) {
      try {
        const refreshToken = localStorage.getItem("refresh");

        if (!refreshToken) {
          // Handle refresh token failure (e.g., redirect to login)
          localStorage.clear();
          window.location.href = "/"; // Redirect to login page
          return request;
        }

        // Create FormData and append the refresh token
        let formData = new FormData();
        formData.append("refresh_token", refreshToken);

        // Send FormData directly as the request body
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}access_token`,
          formData
        );

        if (response.data?.data?.token?.access_token && response.data?.success) {
          const newAccessToken = response.data.data.token.access_token;
          const newRefreshToken = response.data.data.token.refresh_token;
          const expiresIn = response.data.data.token.expires_in;
          const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp

          // Store tokens and user details
          localStorage.setItem("token", newAccessToken);
          localStorage.setItem("refresh", newRefreshToken);
          localStorage.setItem("expires", expiresAt.toString());
          // Update the token variable with the new access token
          token = newAccessToken;
        } else {
          // Handle case where token refresh fails unexpectedly
          localStorage.clear();
          window.location.href = "/";
          return request;
        }
      } catch (error) {
        console.error("Error refreshing token:", error);
        // Handle refresh token failure (e.g., redirect to login)
        localStorage.clear();
        window.location.href = "/";
        return Promise.reject(error);
      }
    }

    // Add the Authorization header with the valid token
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    request.headers.device_type = 1; // Add any other required headers

    return request;
  },
  (err) => Promise.reject(err)
);

export default axiosInstance;
